<template>
    <div class="complete-content">
        <div>
            <div class="row justify-content-center complete_icon">
                <img
                    src="../assets/images/complete_icon.png"
                    alt="complete"
                >
            </div>
            <p class="complete-title">{{$t('completeApplication.title')}}</p>
            <div>
                <!-- 实体礼物 -->
                <p
                    class="complete-desp"
                    v-if="isEntity"
                >
                    {{$t('completeApplication.msgs[0]')}}
                </p>
                <!-- 虚拟礼物 -->
                <p
                    class="complete-desp"
                    v-if="!isEntity"
                >
                    {{$t('completeApplication.msgs[1]')}}<span>{{$store.state.deliverEmail}}</span>{{$t('completeApplication.msgs[2]')}}
                </p>
            </div>
            <div class="msg">
                <div v-if="$store.state.stepTwo.starNum>=4">{{$t('completeApplication.msgs[3]')}}</div>
                <div v-else>{{$t('completeApplication.msgs[4]')}}</div>
            </div>
            <div class="row justify-content-center">
                <button
                    type="button"
                    class="common-comfirm-btn"
                    @click="goHome"
                >
                    {{$t('completeApplication.btnComfirm')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'Complete',
    data() {
        return {
            isEntity: false,   // 虚拟实体礼物文案展示
        }
    },
    components: {

    },
    methods: {
        // 返回首页
        goHome() {
            this.$router.push({ path: '/' })
            this.initData()
        },
        // 初始化数据
        initData() {
            this.$store.state.giftType = null
            this.$store.state.deliverEmail = ''
            this.$store.state.stepTwo.starNum = null
        }
    },
    mounted() {
        if (this.$store.state.giftType === '实体礼物') {
            this.isEntity = true
        } else {
            this.isEntity = false
        }
        // console.info('starNum=', this.$store.state.stepTwo.starNum)
    },
    destroyed() { //组件销毁时
        this.initData()
    }
}
</script>

<style scoped>
.complete-content {
    padding: 150px 275px;
}

.complete_icon {
    margin-bottom: 15px;
}

.complete_icon > img {
    width: 75px;
    height: 75px;
}

.complete-title,
.complete-desp {
    text-align: center;
}

.complete-title {
    font-size: 34px;
    line-height: 44px;
    color: #0c0c0d;
}

.complete-desp {
    font-size: 20px;
    line-height: 26px;
}

.complete-desp > span {
    color: #c6a85b;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
    .complete-content {
        padding: 165px 28px;
    }
    .complete_icon > img {
        width: 50px;
        height: 50px;
    }
    .complete-title {
        font-size: 20px;
        line-height: 20px;
    }
    .complete-desp {
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 25px;
    }
}
.msg {
    color: #c6a85b;
    font-size: 20px;
    margin: 16px 10px 30px;
    text-align: center;
}
</style>